const sass = require('node-sass');
const terminalMessage = require("../../../helpers/terminalMessage");
const componentName = "carousel-steps";
module.exports = async function init(req) {
    var p1 = new Promise(
        async function(resolve, reject) {

            sass.render({
                file: `views/components/${componentName}/${componentName}.scss`,
                sourceComments: false,
                outputStyle: 'compressed'
            }, function(err, result) {

                if (err) {
                    console.log('err', err)
                    reject(err)

                } else {
                    req.style = req.style || ''
                    req.style = req.style + result.css.toString()
                    resolve()
                }
            });
        });

    p1.then(() => terminalMessage
            .success(componentName, req.pageID))
        .catch((_err) => terminalMessage
            .error(componentName, req.pageID));
    return p1
}
